// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"2c4331cd","370":"a3dd5a2b","483":"06a76cf6","535":"e89f5c42","707":"1f31dd74","735":"429a870c","765":"c2863282","848":"e36893ad","962":"8cf47dc7"}[chunkId] + ".chunk.js";
};